// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/484f6921ede2331547bd.bundle.js";
	if (chunkId === 3) return "static/js/4cf9ae86d9f6e1286884.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"45dd6e43cabaa2833466","139":"3cc5bca5d88a8026405b","140":"be0c19ad42f78a479e1a"}[chunkId] + ".chunk.js";
};